import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { NonNullableGenericState, Promotion, ReducerUtil, SelectorUtil } from '@us/web/shared/data-access';
import { PromotionsActions } from './promotions.actions';

export const PROMOTIONS_FEATURE_KEY = 'promotions';

export type PromotionsState = NonNullableGenericState<Promotion[]>;

export const initialState: PromotionsState = {
    data: [],
    status: 'pending',
    error: null
};

export const promotionsFeature = createFeature({
    name: PROMOTIONS_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(PromotionsActions.loadPromotions, ReducerUtil.setLoading),
        on(PromotionsActions.loadPromotionsSuccess, (state, { promotions }) =>
            ReducerUtil.setSuccess(state, promotions)
        ),
        on(PromotionsActions.loadPromotionsFailure, ReducerUtil.setFailed)
    )
});

export const {
    name,
    reducer,
    selectPromotionsState,
    selectData: selectPromotions,
    selectStatus,
    selectError
} = promotionsFeature;

export const selectLoading = createSelector(selectPromotionsState, SelectorUtil.isLoading);

export const selectPromotionsUserSelect = createSelector(selectPromotions, promotions => promotions);
